import React from "react";
import CarMaintenanceStyles from "./CarMaintenance.module.css"; // Import the CSS module
import { Link, useNavigate } from "react-router-dom";
import ReactGA from  "react-ga4";

function CarMaintenance() {
  const navigate = useNavigate();
  const handleCarServicing = () =>{
    ReactGA.gtag("event", "hp_services_clicked", {    
      event_category: "containBtn", 
      event_label: "Home_Page_UI",
      value: 1,
      service: "car_servicing",
      button : "book_now"
    });
    navigate("/car-servicing");
  }
  return (
    <div className={CarMaintenanceStyles.CarMaintance_MainDiv}>
      <div className={CarMaintenanceStyles.CarMaintance_ImageDiv}>
        <img
          src="https://ik.imagekit.io/driveu/Web/Car_Maintanance_IMage_-qkR6Imkz.png"
          alt="Car Maintenance"
          loading="lazy"
          className={CarMaintenanceStyles.CarMaintenece_CarImage}
        />
        <img
          src="https://ik.imagekit.io/driveu/Web/Car_Maintanance_IMage_-qkR6Imkz.png"
          alt="Car Maintenance"
          loading="lazy"
          className={CarMaintenanceStyles.CarMaintenece_CarImage_Mobile}
        />
      </div>
      <div className={CarMaintenanceStyles.CarMaintance_TextDiv}>
        <h2 className={CarMaintenanceStyles.Maintenance_care_Heading}>
          Car Maintenance & Care
        </h2>
        {/* <br className="break-line" /> */}
        <div className={CarMaintenanceStyles.Maintenece_care_content}>
          Discover and book the best car services and maintenance options near
          you. Seamless booking experience and secure online payments.
        </div>
        <div onClick={handleCarServicing}>
          <button className={CarMaintenanceStyles.CarMaintenece_bookNow}>
            <span
              style={{
                textAlign: "center",
              }}
              className={CarMaintenanceStyles.Book_Now}
            >
              Book Now
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default CarMaintenance;
